export default __webpack_public_path__ + "static/media/Cristian Raimo.93c2f87c.jpg";